import moment from "moment";
export const getCurrentMealFromCart = (meals, date, programMealId) => meals.find((meal) => meal.ProgramMealId === programMealId && moment(meal.MealDate).isSame(date, "date"));
